require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j.json") })
        }
      }, "path---kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j!./.cache/json/kriterien-wochenoeffnungszeiten-oeff-woche-3-6-j.json
// module id = 1135
// module chunks = 231608221292675